<header class="premium-global-header">
    <!-- Start Top Bar -->
    <div *ngIf="isBig" class="top-utility-bar modern-top-bar">
        <div class="container d-flex justify-content-between align-items-center">
            <div class="contact-info d-flex align-items-center text-white">
                <span class="badge-item me-4"><i class="fa-solid fa-phone me-2 text-warning"></i>{{ mainData?.Phone
                    || mainData?.ContactNo }}</span>
                <span class="badge-item me-4"><i class="fa-solid fa-envelope me-2 text-warning"></i>{{ mainData?.Email
                    }}</span>
                <span class="badge-item"><i class="fa-solid fa-location-dot me-2 text-warning"></i>{{
                    mainData?.Address }}</span>
            </div>
            <div class="top-actions d-flex align-items-center text-white">
                <!-- <span class="me-3 fw-bold" style="font-size: 13px; cursor: pointer;">বাংলা | English</span> -->
                <a class="social-btn facebook" href="https://www.facebook.com/kmsc2001/?locale=bn_IN" target="_blank"><i
                        class="fa-brands fa-facebook-f"></i></a>
                <a class="social-btn youtube" href="https://www.youtube.com/channel/UCIE05ptL3gBRM8GJuBuKPbw"
                    target="_blank"><i class="fa-brands fa-youtube"></i></a>
            </div>
        </div>
    </div>

    <!-- Mobile Header Top Bar -->
    <div *ngIf="isSmall" class="top-utility-bar-mobile modern-top-bar text-center text-white p-2">
        <div class="d-flex flex-column gap-1">
            <span><i class="fa-solid fa-phone me-2 text-warning"></i>{{ mainData?.ContactNo1 || mainData?.ContactNo ||
                '8801713228443' }}</span>
            <span><i class="fa-solid fa-envelope me-2 text-warning"></i>{{ mainData?.Email || 'kmsc2001@gmail.com'
                }}</span>
        </div>
        <div class="mt-2 d-flex justify-content-center align-items-center">
            <!-- <span class="me-3 fw-bold" style="font-size: 13px; cursor: pointer;">বাংলা | English</span> -->
            <a class="social-btn facebook me-2" href="https://www.facebook.com/kmsc2001/?locale=bn_IN"><i
                    class="fa-brands fa-facebook-f"></i></a>
            <a class="social-btn youtube" href="https://www.youtube.com/channel/UCIE05ptL3gBRM8GJuBuKPbw"><i
                    class="fa-brands fa-youtube"></i></a>
        </div>
    </div>
    <!-- End Top Bar -->

    <div class="clearfix"></div>

    <!-- Start Navbar Area -->
    <div class="navbar-area luxury-navbar-ribbon" style="background-color: #ffffff !important;">
        <div class="karlson-nav modern-3d-nav" style="background-color: #ffffff !important;">
            <nav class="navbar navbar-expand-lg w-100 p-0" style="background-color: #ffffff !important;">
                <div class="container d-lg-none d-flex justify-content-between align-items-center py-2">
                    <a class="navbar-brand ms-1 d-flex align-items-center text-decoration-none" routerLink="/">
                        <img src="../../../../assets/img/new_logo.png" alt="logo" class="logo me-2"
                            style="max-height: 50px; background: white; padding: 4px; border-radius: 6px;">
                        <div class="brand-title-box">
                            <div class="college-name-mobile m-0 p-0"
                                style="font-size: 16px; color: #026928; font-weight: 700; line-height: 1.2;">করতোয়া
                                মাল্টিমিডিয়া</div>
                            <div class="college-name-mobile m-0 p-0"
                                style="font-size: 16px; color: #dc3545; font-weight: 700; line-height: 1.2;">স্কুল এন্ড
                                কলেজ</div>
                        </div>
                    </a>
                    <button class="navbar-toggler custom-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>

                <div class="collapse navbar-collapse mean-menu w-100 py-2 py-lg-0 flex-column"
                    id="navbarSupportedContent" *ngIf="isBig" style="background-color: #ffffff !important;">

                    <!-- Top Row: Brand & Login -->
                    <div class="container">
                        <div class="w-100 d-flex justify-content-between align-items-center pb-2 pt-1 desktop-brand-row"
                            style="border-bottom: 1px solid rgba(0,0,0,0.05);">
                            <!-- Brand -->
                            <a class="brand-wrapper d-flex align-items-center text-decoration-none" routerLink="/">
                                <ng-container *ngIf="mainData != null">
                                    <img [src]="mainData.LogoUrl" alt="Logo" class="me-3"
                                        style="background: white; padding: 2px; height: 95px !important; width: 95px !important; border-radius: 8px;" />
                                </ng-container>
                                <div class="brand-title-box">
                                    <h1 class="college-name mb-1 brand-text-3d"
                                        style="font-size: clamp(18px, 1.8vw, 26px); font-weight: 800; color: #026928;">
                                        করতোয়া মাল্টিমিডিয়া <span style="color: #dc3545;">স্কুল এন্ড কলেজ</span>
                                    </h1>
                                    <div style="font-size: 14px; color: #333; font-weight: 700;">স্থাপিত: ২০০১</div>
                                </div>
                            </a>

                            <!-- Login Button -->
                            <div class="d-flex align-items-center">
                                <a href="https://portal.cloudcampus24.com/" target="_blank" class="btn-3d">
                                    <i class="fa-solid fa-lock me-2"></i> <i class="fa-solid fa-user me-1"></i> লগইন
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Bottom Row: Menus -->
                    <div class="w-100 py-2 menu-bar-bg">
                        <div class="container">
                            <ul
                                class="navbar-nav d-flex justify-content-between align-items-center flex-nowrap w-100 mb-0 px-3">
                                <li class="nav-item">
                                    <a routerLink="/" class="nav-link" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"><i class="fa-solid fa-house"></i></a>
                                </li>
                                <ng-container *ngFor="let items of AllmenuItems">
                                    <!-- Dropdown Menu Item -->
                                    <li class="nav-item dropdown" *ngIf="items.Items && items.Items.length > 0">
                                        <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                            data-bs-toggle="dropdown" routerLinkActive="active">
                                            {{ items.DisplayNameBangla || items.MenuName }} <i
                                                class="fa-solid fa-angle-down ms-1" style="font-size: 12px;"></i>
                                        </a>
                                        <ul class="dropdown-menu">
                                            <ng-container *ngFor="let item of items.Items">
                                                <li>
                                                    <!-- Internal Link -->
                                                    <a class="dropdown-item" *ngIf="!item.MenuUrl?.startsWith('http')"
                                                        [routerLink]="item.MenuUrl ? '/' + item.MenuUrl.trim() : null"
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{exact: true}">{{
                                                        item.DisplayNameBangla || item.MenuName }}</a>
                                                    <!-- External Link -->
                                                    <a class="dropdown-item" *ngIf="item.MenuUrl?.startsWith('http')"
                                                        [href]="item.MenuUrl.trim()" target="_blank">{{
                                                        item.DisplayNameBangla || item.MenuName }}</a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </li>
                                    <!-- Single Menu Item -->
                                    <li class="nav-item" *ngIf="!items.Items || items.Items.length === 0">
                                        <a *ngIf="!items.MenuUrl?.startsWith('http')"
                                            [routerLink]="items.MenuUrl ? '/' + items.MenuUrl.trim() : null"
                                            class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">{{
                                            items.DisplayNameBangla || items.MenuName }}</a>
                                        <a *ngIf="items.MenuUrl?.startsWith('http')" [href]="items.MenuUrl.trim()"
                                            target="_blank" class="nav-link">{{
                                            items.DisplayNameBangla || items.MenuName }}</a>
                                    </li>
                                </ng-container>
                            </ul>
                        </div>
                    </div>

                </div>

                <div class="collapse navbar-collapse mean-menu-new w-100 menu-bar-bg-mobile" id="navbarSupportedContent"
                    *ngIf="isSmall">
                    <ul class="navbar-nav w-100 d-flex flex-column text-start pb-3 pt-2">
                        <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"><i class="fa-solid fa-house"></i></a></li>
                        <ng-container *ngFor="let items of AllmenuItems">
                            <!-- Dropdown Menu Item -->
                            <li class="nav-item dropdown" *ngIf="items.Items && items.Items.length > 0">
                                <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button"
                                    data-bs-toggle="dropdown" aria-expanded="false" routerLinkActive="active">
                                    {{ items.DisplayNameBangla || items.MenuName }} <i
                                        class="fa-solid fa-angle-down ms-1" style="font-size: 12px;"></i>
                                </a>
                                <ul class="dropdown-menu">
                                    <ng-container *ngFor="let item of items.Items">
                                        <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
                                            <a class="nav-link" *ngIf="!item.MenuUrl?.startsWith('http')"
                                                [routerLink]="item.MenuUrl ? '/' + item.MenuUrl.trim() : null"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{
                                                item.DisplayNameBangla || item.MenuName }}</a>
                                            <a class="nav-link" *ngIf="item.MenuUrl?.startsWith('http')"
                                                [href]="item.MenuUrl.trim()" target="_blank">{{
                                                item.DisplayNameBangla || item.MenuName }}</a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </li>
                            <!-- Single Menu Item -->
                            <li class="nav-item" *ngIf="!items.Items || items.Items.length === 0" data-toggle="collapse"
                                data-target=".navbar-collapse.show">
                                <a *ngIf="!items.MenuUrl?.startsWith('http')"
                                    [routerLink]="items.MenuUrl ? '/' + items.MenuUrl.trim() : null" class="nav-link"
                                    routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{
                                    items.DisplayNameBangla || items.MenuName }}</a>
                                <a *ngIf="items.MenuUrl?.startsWith('http')" [href]="items.MenuUrl.trim()"
                                    target="_blank" class="nav-link">{{
                                    items.DisplayNameBangla || items.MenuName }}</a>
                            </li>
                        </ng-container>
                        <li class="nav-item mt-3 px-3 d-flex justify-content-start">
                            <a class="btn-3d w-100 text-center" href="https://portal.cloudcampus24.com/"
                                target="_blank">
                                <i class="fa-solid fa-lock me-1"></i> লগইন
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <!-- End Navbar Area -->
</header>